import gql from "graphql-tag";
import PropTypes from "prop-types";

export default {
  mutation: gql`
    mutation addServiceDeskRequest(
      $requester: String!
      $subject: String!
      $description: String!
      $category: String
      $subcategory: String
    ) {
      createServicedeskRequest(
        requester: $requester
        subject: $subject
        description: $description
        category: $category
        subcategory: $subcategory
      ) {
        success
        message
      }
    }
  `,
  config: {
    skip: (ownProps) => !ownProps.cardId,
    options: ({ requester, subject, description, category, subcategory }) => ({
      variables: {
        requester,
        subject,
        description,
        category,
        subcategory,
      },
    }),
  },
  propTypes: {
    requester: PropTypes.string.isRequired,
    subject: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    category: PropTypes.string,
    subcategory: PropTypes.string,
  },
};



// WEBPACK FOOTER //
// ./src/model/gql/mutations/sd/serviceDeskRequest/addServiceDeskRequest.js